var map = {
	"./apple-laurel-da-DK.svg": 58955,
	"./apple-laurel-de-DE.svg": 18617,
	"./apple-laurel-en-GB.svg": 17203,
	"./apple-laurel-en-US.svg": 76652,
	"./apple-laurel-es-ES.svg": 73931,
	"./apple-laurel-es-MX.svg": 46520,
	"./apple-laurel-fr-FR.svg": 89167,
	"./apple-laurel-it-IT.svg": 55697,
	"./apple-laurel-nb-NO.svg": 8498,
	"./apple-laurel-nl-NL.svg": 90823,
	"./apple-laurel-pl-PL.svg": 97355,
	"./apple-laurel-pt-BR.svg": 74883,
	"./apple-laurel-pt-PT.svg": 50827,
	"./apple-laurel-sv-SE.svg": 5194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;